/**
 * Tiny typed event emitter shared by the controller (and available to adapters).
 * Kept separate from the state store: state is a snapshot you read, events are
 * moments you react to.
 */
export class Emitter {
    listeners = new Map();
    on(event, listener) {
        let set = this.listeners.get(event);
        if (!set) {
            set = new Set();
            this.listeners.set(event, set);
        }
        const entry = listener;
        set.add(entry);
        return () => {
            set?.delete(entry);
        };
    }
    emit(event, payload) {
        const set = this.listeners.get(event);
        if (!set)
            return;
        for (const listener of [...set]) {
            listener(payload);
        }
    }
    clear() {
        this.listeners.clear();
    }
}
//# sourceMappingURL=emitter.js.map